import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import constants from "../../utils/constants";
import parse from "html-react-parser"; 


const ReturnPolicy = () => {
  const theme = useTheme();
  const { return_policy } = constants;

  return (
    <Box sx={{ width: "100%", mt: 4, overflow: "hidden", px: 3 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.primary.main, mb: 1 }}>
        {return_policy.title}
      </Typography>

      {/* Intro Note */}
      <Typography variant="body1" sx={{ color: theme.palette.heading_color.main, mb: 2, fontStyle: "italic", fontWeight: "bold" }}>
        {return_policy.note}
      </Typography>

      <Box sx={{ mb: 2 }}>
              {[
                  { title: return_policy.heading1, content: return_policy.heading1_note },
                  { title: return_policy.heading2, content: return_policy.heading2_note },
                  { title: return_policy.heading3, content: return_policy.heading3_note },
                  { title: return_policy.heading5, content: return_policy.heading5_note },
                  { title: return_policy.heading6, content: return_policy.heading6_note },
              ].map((section, index) => (
                  <Box key={index}>
                  <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
                      {section.title}
                  </Typography>
                  <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                      {section.content.split("\n\n").map((line, lineIndex) => {
                      const spaces = line.match(/^(\s*)/)?.[0]?.length || 0;
                      const indentLevel = spaces / 2;
                      return (
                          <Box 
                          component="li" 
                          key={lineIndex} 
                          sx={{ pl: `${indentLevel * 10}px`, color: theme.palette.heading_color.main, mb: 1 }}
                          >
                          {parse(line.replace("• ", ""))} 
                          </Box>
                      );
                      })}
                  </Box>
                  </Box>
              ))}
            </Box>

            <Box sx={{ mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
                    {return_policy.heading4}
                </Typography>
                <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                    {return_policy.heading4_note.split("\n\n").map((line, lineIndex) => {
                    // Count leading spaces to determine indent level
                    const spaces = line.match(/^(\s*)/)?.[0]?.length || 0;
                    const indentLevel = spaces / 2;
        
                    // Split further if the line contains `\n`
                    return line.split("\n").map((subLine, subIndex) => {
                        const isIndented = subIndex > 0; // If it's not the first line, increase indentation
                        return (
                        <Box
                            component="li"
                            key={`${lineIndex}-${subIndex}`}
                            sx={{
                            pl: `${(indentLevel + (isIndented ? 2 : 0)) * 10}px`, // Extra indentation for sub-points
                            color: theme.palette.heading_color.main,
                            mb: 1,
                            listStyleType: isIndented ? `"◦  "` : `"•  "`, // ◦ for sub-items
                            }}
                        >
                            {parse(subLine.replace("• ", ""))}

                        </Box>
                        );
                    });
                    })}
                </Box>
                </Box>

             <Box sx={{ mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
                    {return_policy.heading7}
                </Typography>
                <Box sx={{ mt: 1, color:theme.palette.heading_color.main }}>
                    {return_policy.heading7_note.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                        {line}
                        <br />
                        </React.Fragment>
                    ))}
                </Box>
            </Box>

    </Box>
  );
};

export default ReturnPolicy;
